import { render, staticRenderFns } from "./NewToDo.vue?vue&type=template&id=d1ed32f0&scoped=true"
import script from "./NewToDo.vue?vue&type=script&lang=js"
export * from "./NewToDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ed32f0",
  null
  
)

export default component.exports